<template>
    <div class="w-full bg-gray-50 border-t-2 px-2 sm:px-8 py-3 d-flex flex-col sm:flex-row justify-between items-center gap-2">
        <h3 class="text-center">{{ config.credit }}. All Rights Reserved. <br class="d-md-none">Phiên bản {{ version }}.</h3>
        <div class="d-flex justify-content-center" style="gap: 10px;">
            <a :href="config.facebook"><i class='bx bx-md bxl-facebook-circle'></i></a>
            <a :href="config.youtube"><i class='bx bx-md bxl-youtube' ></i></a>
            <a :href="'mailto:' + config.email"><i class='bx bx-md bxs-envelope' ></i></a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    props: {
        config: Object
    },
    created() {
        this.version = process.env.VUE_APP_VERSION
    },
}
</script>